module.exports = "<div ng-form=\"form\">\n  <div class=\"input-field\"\n    ng-class=\"{success: ngModel}\">\n    <label for=\"select\">\n      <span ng-if=\"required\"\n        class=\"asterisk\">*</span>\n    </label>\n\n    <select class=\"select-active\"\n      name=\"select\"\n      ng-model=\"ngModel\"\n      ng-options=\"{{selectOptions}}\"\n      ng-required=\"required\">\n      <option value=\"\">-- {{label}} --</option>\n    </select>\n\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/global/directives/inputs/mySelect.html
// module id = 1225
// module chunks = 0